// extracted by mini-css-extract-plugin
module.exports = {"loginBackgroundContainer":"Login_loginBackgroundContainer__2tBK_","loginRightSubTitle":"Login_loginRightSubTitle__15hhk"};